// Empire is a Kentico Page Builder site, so widget markup can be injected after
// load. RelayCustomElementClient hydrates from <relay-component>'s own
// connectedCallback rather than scanning the DOM once, which covers that case.
import { RelayCustomElementClient } from '@relay/client';
import React from 'react';
import { flushSync } from 'react-dom';
import { hydrateRoot, type Root } from 'react-dom/client';
import { registrations } from '../../.relay/registrations';

const relay = new RelayCustomElementClient(registrations, async (registration, props, container) => {
  const { default: Component } = await registration.import();

  let reactComponent: React.ReactNode = React.createElement(Component, props as Record<string, unknown>);

  // if development wrap the component in a React.StrictMode
  if (process.env.NODE_ENV === 'development') {
    reactComponent = React.createElement(React.StrictMode, undefined, reactComponent);
  }

  let root: Root;

  flushSync(() => {
    root = hydrateRoot(container, reactComponent);
  });

  // Disposer: ignored by RelayClient, used by RelayCustomElementClient to
  // unmount when the element leaves the DOM.
  return () => root.unmount();
});

relay.initialise();
